import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CodeInput from './mfaCode';
import customConfig from "../../config";
import QRdisplay from './mfaQR';
import Popup from "../layout/Popup";
import loginLogo from "../../assets/black_logo.png";

const MfaQrCode = ({ qrCodeUrl, tenantData }) => {
  const [showInstructions, setShowInstructions] = useState(false);
  const [showCodes, setShowCodes] = useState(false);

  const handleInstructionsClick = (e) => {
    e.preventDefault();
    setShowInstructions(true);
  };

  const closeInstructions = () => {
    setShowInstructions(false);
  };

  const handleContinue = () => {
    setShowCodes(true);
  };

  return (
    <Fragment>
      <div className="login-wrapper">
        <div className="login-box">
          <div className="form-box">
            <div className="row mb-0">
              <div className="col s12 center-align">
                <img
                  src={tenantData?.tenantLogoUrl || loginLogo}
                  alt="Logo"
                  className="logo-outer"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = loginLogo;
                  }}
                />
              </div>
            </div>
            {showInstructions && (
              <Popup visible={showInstructions} notifyPopupClose={closeInstructions}>
                <div className="qr-popup-container">
                  <h2>Set up 2-Step Authentication</h2>
                  <ol>
                    {customConfig.mfaSetupInstuctions.map((instruction, index) => (
                     <li key={index}>{instruction}</li> ))
                    }
                  </ol>
                </div>
              </Popup>
            )}
            {!showCodes ? (
              <>
                <QRdisplay/>
                <div className="row mb-0">
                  <div className="input-field p-0 col s12">
                    <button
                      onClick={handleContinue}
                      className="btn add-btn xl col s12 mTop20"
                      type="button"
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <CodeInput />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

MfaQrCode.propTypes = {
  qrCodeUrl: PropTypes.string.isRequired,
  tenantData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  qrCodeUrl: state.auth.qrCodeUrl,
});

export default connect(mapStateToProps)(MfaQrCode);
